var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbastecimentoAgua = function SvgAbastecimentoAgua(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17C21.3333 18.2636 22 19.2636 22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 19.2636 18.6667 18.2636 20 17ZM3.5 8C3.74855 8 3.95471 8.22901 3.99346 8.52912L4 8.63158V15.3684C4 15.6824 3.8187 15.9428 3.58111 15.9917L3.5 16H2.5C2.25145 16 2.04529 15.771 2.00654 15.4709L2 15.3684V8.63158C2 8.31762 2.1813 8.05721 2.41889 8.00827L2.5 8H3.5ZM13 6C13.5523 6 14 6.44772 14 7V8C15.1046 8 16 8.89543 16 10H18C20.2091 10 22 11.7909 22 14V15H18V14H16C16 15.1046 15.1046 16 14 16H10C8.89543 16 8 15.1046 8 14H7C6.44772 14 6 13.5523 6 13V11C6 10.4477 6.44772 10 7 10H8C8 8.89543 8.89543 8 10 8V7C10 6.44772 10.4477 6 11 6H13ZM14.5263 2C14.7589 2 14.9523 2.17685 14.9924 2.41012L15 2.5V3.5C15 3.74549 14.8325 3.94961 14.6115 3.99195L14.5263 4H9.47368C9.24112 4 9.04773 3.82315 9.00763 3.58988L9 3.5V2.5C9 2.25451 9.16754 2.05039 9.38853 2.00805L9.47368 2H14.5263Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbastecimentoAgua, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/abastecimento-agua.b312b14d.svg";
export { ForwardRef as ReactComponent };